import { Divider, Flex, Tag, Text, Tooltip } from '@chakra-ui/react';
import { formatPercent } from '~/common/utils/formatter';
import { formatToCurrency } from '~/services/document/utils/number';
import { BidAskDetails } from './KeyTermsRow';

export const PurchasePriceTooltip = ({
  listPrice,
  bidAsk,
  placeholder,
  children,
  isOpen,
}: {
  listPrice?: number;
  bidAsk?: BidAskDetails;
  placeholder?: number;
  children: React.ReactNode;
  isOpen: boolean;
}) => {
  const tooltipContent = (
    <Flex direction="column" gap={1}>
      <Flex alignItems="center" gap={2} justifyContent="space-between">
        <Text>List Price</Text>
        <Tag borderRadius="3px" color="whiteAlpha.600" size="sm">
          {formatToCurrency(listPrice)}
        </Tag>
      </Flex>
      <Text fontSize="sm">Comps sale / list</Text>
      {bidAsk?.min && (
        <Flex
          alignItems="center"
          color="whiteAlpha.600"
          gap={2}
          justifyContent="space-between"
        >
          <Text fontSize="xs">Min</Text>
          <Tag borderRadius="3px" color="whiteAlpha.600" size="sm">
            {formatPercent(bidAsk.min - 1)}
          </Tag>
        </Flex>
      )}
      {bidAsk?.max && (
        <Flex
          alignItems="center"
          color="whiteAlpha.600"
          gap={2}
          justifyContent="space-between"
        >
          <Text fontSize="xs">Max</Text>
          <Tag borderRadius="3px" color="whiteAlpha.600" size="sm">
            {formatPercent(bidAsk.max - 1)}
          </Tag>
        </Flex>
      )}
      <Flex
        alignItems="center"
        color="whiteAlpha.600"
        gap={2}
        justifyContent="space-between"
      >
        <Text fontSize="xs">Avg</Text>
        <Tag borderRadius="3px" color="whiteAlpha.600" size="sm">
          {formatPercent(bidAsk ? bidAsk.avg - 1 : 0)}
        </Tag>
      </Flex>
      <Divider />
      <Flex alignItems="center" gap={2} justifyContent="space-between">
        <Text>Adjusted List Price</Text>
        <Tag borderRadius="3px" color="whiteAlpha.600" size="sm">
          {formatToCurrency(placeholder)}
        </Tag>
      </Flex>
    </Flex>
  );

  return (
    <Tooltip
      isOpen={isOpen}
      label={tooltipContent}
      placement="top"
      variant="muted"
    >
      {children}
    </Tooltip>
  );
};
